import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ListWrapper from "../utils/ListWrapper" ;
import DateTimeField from "./DateTimeField" ;
import TextView from "./TextView" ;
import DateTime from "../core/DateTime" ;
import { BuildContext } from "../classes/BuildContext" ;

type _LabelWithDateTimeFieldOnChanged = ( value : DateTime ) => void ;


  export  interface  LabelWithDateTimeFieldProps extends  BaseUIProps {   key?: string ;
   name: string ;
   placeHolder?: string ;
   isRequired?: boolean ;
   value: DateTime ;
   errors?: Array<string> ;
   _errorsHash?: number ;
   onChanged?: _LabelWithDateTimeFieldOnChanged ;
 }

   class  _LabelWithDateTimeFieldState extends  ObservableComponent<LabelWithDateTimeFieldProps> {   static defaultProps = { name:'', placeHolder:'', isRequired:false, value:null, errors:[], onChanged:null } ;
   focusNode: ui.FocusNode = null ;
   active: boolean = false ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : LabelWithDateTimeFieldProps ) {
 super(props);

this.initState();
 }
  public get name (  ) : string {
 return this.props.name ; 
 }
  public get placeHolder (  ) : string {
 return this.props.placeHolder ; 
 }
  public get isRequired (  ) : boolean {
 return this.props.isRequired ; 
 }
  public get value (  ) : DateTime {
 return this.props.value ; 
 }
  public get errors (  ) : Array<string> {
 return this.props.errors ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.subscribeToList(this.errors,'errors');

this.on([ 'errors', 'isRequired', 'name', 'placeHolder', 'value' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : LabelWithDateTimeFieldProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.name !== this.props.name ) {
 this.fire('name',this);
 }

if ( prevProps.placeHolder !== this.props.placeHolder ) {
 this.fire('placeHolder',this);
 }

if ( prevProps.isRequired !== this.props.isRequired ) {
 this.fire('isRequired',this);
 }

if ( prevProps.value !== this.props.value ) {
 this.fire('value',this);
 }

if ( prevProps.errors !== this.props.errors ) {
 this.fire('errors',this);
 }
 }
  public setFocusNode ( val : ui.FocusNode ) : void {
 let isValChanged :boolean=this.focusNode !== val;

if ( !isValChanged ) {
 return ; 
 }

this.focusNode=val;

this.fire('focusNode',this);
 }
  public setActive ( val : boolean ) : void {
 let isValChanged :boolean=this.active !== val;

if ( !isValChanged ) {
 return ; 
 }

this.active=val;

this.fire('active',this);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ crossAxisAlignment:cStyle.tColumnFieldStyleCrossAxisAlignmentOn, children:[ ((this.name !== null && this.name.isNotEmpty) ? ui.Row({ children:[ TextView({ data:this.name, style:new ui.TextStyle({color:cStyle.tTextViewLabelTextColorOn,fontSize:cStyle.tTextViewLabelTextFontSizeOn,fontWeight:cStyle.tTextViewLabelTextFontWeightOn}), className:'LabelText x8643', key:'0' }), ((this.isRequired) ? TextView({ data:'*', style:new ui.TextStyle({color:new ui.Color(0xffc20f2f),fontSize:cStyle.tTextViewLabelTextFontSizeOn,fontWeight:cStyle.tTextViewLabelTextFontWeightOn}), className:'LabelText xf1' }) : [  ]) ], className:'x770 hc h' }) : [  ]), ui.Container({ padding:ui.EdgeInsets.symmetric({horizontal:10.0,vertical:5.0,transitions:new Map()}), child:DateTimeField({ value:this.value, placeHolder:this.placeHolder, activeColor:cStyle.c1, inActiveColor:this.errors.isNotEmpty ? new ui.Color(0xffc20f2f) : new ui.Color(0xffd2d2d2), cornerRadius:4, onChanged:( dateTime ) => {
 this.onChangeText(dateTime);
 }
 }), key:'1', className:'xb04 hc h' }), ((this.errors.isNotEmpty) ? ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ (this.errors).expand(( item ) => [ TextView({ data:item, textAlign:cStyle.tTextViewErrorTextTextAlignOn, style:new ui.TextStyle({color:cStyle.tTextViewErrorTextColorOn}), className:'ErrorText x816 hc', key:item?.toString() }) ]) ], className:'hc' }) : [  ]) ], className:ui.join('FieldStyle LabelWithDateTimeField x50e8 hc h ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setFocusNode(new ui.FocusNode());

this.focusNode.addListener(this.onChangeFocus);
 }
  public onChangeFocus  =  (  ) : void  =>  {
 this.setActive(this.focusNode.hasFocus);
 }
  public onChangeText  =  ( dateTime : DateTime ) : void  =>  {
 if ( this.onChanged !== null ) {
 this.onChanged(dateTime);
 }
 }
  public get onChanged (  ) : _LabelWithDateTimeFieldOnChanged {
 return this.props.onChanged ; 
 }
 }
export default function LabelWithDateTimeField ( props : LabelWithDateTimeFieldProps ) {
 return React.createElement(_LabelWithDateTimeFieldState,{ ..._LabelWithDateTimeFieldState.defaultProps, ...props },ListWrapper.fromInput<string>(props.errors,'errors')) ; 
 }
